function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.137 8.2c.265 0 .502.165.594.413l1.903 5.072a.634.634 0 11-1.189.447l-.32-.857H2.15l-.321.857a.634.634 0 11-1.188-.447l1.902-5.072a.634.634 0 01.594-.413zm8.244-2.597c.35 0 .634.284.634.634v6.078l1.454-1.454a.634.634 0 01.898.897l-2.537 2.536a.634.634 0 01-.898 0l-2.536-2.536a.634.634 0 01.897-.897l1.454 1.454V6.237c0-.35.283-.634.634-.634zm-8.244 5.039l-.512 1.364H3.65l-.512-1.364zM8.601.578a.634.634 0 01.692.138l2.536 2.536a.634.634 0 01-.897.897L9.478 2.695v5.444a.634.634 0 01-1.268 0V2.695L6.755 4.149a.634.634 0 01-.897-.897L8.395.716c.059-.06.129-.106.206-.138zM5.04.5a.634.634 0 01.507 1.015L2.503 5.573H5.04a.634.634 0 110 1.268H1.235a.634.634 0 01-.507-1.014L3.77 1.768H1.235a.634.634 0 110-1.268z",
  fill: "#54585D"
}))));